var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"base-spinner fa-3x"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }